<template>
    <div class="layout">
        <el-container>
            <el-header>
                <Header />
            </el-header>
            <el-main class="mainwrap">
                <router-view></router-view>
                <Footer />
            </el-main>
        </el-container>
        <el-backtop target=".mainwrap" :bottom="80"></el-backtop>
    </div>
</template>

<script>
import Header from './Header.vue';
import Footer from './Footer.vue';
export default {
    components: {
        Header,
        Footer
    },
    name: 'OfficialWebsiteLayout',

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.layout {
    height: 100%;

    .el-container {
        height: 100%;

        .el-header {
            height: 100px !important;
            padding: 0;
        }

        .el-main {
            padding: 0;
        }
    }
}
@media (min-width:430px) {
    .layout{
        .el-backtop{
            width: 70px;
            height: 70px;
           font-size: 36px;
        }
    }
}
</style>